import * as ActionTypes from '../store/ActionTypes';
export const actionCreators = {
    currentNavigation: (response) => ({ type: ActionTypes.currentNavigation, payload: response }),
};

export const updateRedirect = (response) => {
    return dispatch => {
        dispatch(actionCreators.currentNavigation(response));
    }
}